import { render, staticRenderFns } from "./ns-order-instalments-payment.vue?vue&type=template&id=3e51b49b&"
import script from "./ns-order-instalments-payment.vue?vue&type=script&lang=js&"
export * from "./ns-order-instalments-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports